import React, { forwardRef, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../assets/css/PasswordInput.css";

/** Password <input> with an eye button to show / hide the text. Takes the same props as <input>. */
const PasswordInput = forwardRef(function PasswordInput({ className = "", wrapperClassName = "", ...props }, ref) {
  const [visible, setVisible] = useState(false);
  return (
    <span className={`password-input${wrapperClassName ? ` ${wrapperClassName}` : ""}`}>
      <input
        {...props}
        ref={ref}
        type={visible ? "text" : "password"}
        className={`password-input__field${className ? ` ${className}` : ""}`}
      />
      <button
        type="button"
        className="password-input__toggle"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        title={visible ? "Hide password" : "Show password"}
        disabled={props.disabled}
      >
        {visible ? <FaEyeSlash aria-hidden="true" /> : <FaEye aria-hidden="true" />}
      </button>
    </span>
  );
});

export default PasswordInput;
